export const iso6391: any = {
  aa: 'Afaraf',
  ab: 'Аҧсуа',
  ae: 'Avesta',
  af: 'Afrikaans',
  ak: 'Akan',
  am: 'አማርኛ',
  an: 'Aragonés',
  ar: 'العربية',
  as: 'অসমীয়া',
  av: 'авар мацӀ ; магӀарул мацӀ',
  ay: 'Aymar aru',
  az: 'Azərbaycan dili',
  ba: 'башҡорт теле',
  be: 'Беларуская',
  bg: 'български език',
  bh: 'भोजपुरी',
  bi: 'Bislama',
  bm: 'Bamanankan',
  bn: 'বাংলা',
  bo: 'Tibetan',
  br: 'Brezhoneg',
  bs: 'Bosanski jezik',
  ca: 'Català',
  ce: 'нохчийн мотт',
  ch: 'Chamoru',
  co: 'Corsu',
  cr: 'ᓀᐦᐃᔭᐍᐏᐣ',
  cs: 'Čeština',
  cu: 'ѩзыкъ словѣньскъ',
  cv: 'чӑваш чӗлхи',
  cy: 'Cymraeg',
  da: 'Dansk',
  de: 'Deutsch',
  dv: 'ދިވެހި',
  dz: 'Dzongkha',
  ee: 'Ewe',
  el: 'Ελληνικά',
  en: 'English',
  eo: 'Esperanto',
  es: 'Español',
  et: 'Eesti keel',
  eu: 'Euskara',
  fa: 'فارسی',
  ff: 'Fulfulde',
  fi: 'Suomen kieli',
  fj: 'Vosa Vakaviti',
  fo: 'Føroyskt',
  fr: 'Français',
  fy: 'Frysk',
  ga: 'Gaeilge',
  gd: 'Gàidhlig',
  gl: 'Galego',
  gn: "Avañe'ẽ",
  gu: 'ગુજરાતી',
  gv: 'Gaelg',
  ha: 'Hausa',
  he: 'עברית',
  hi: 'हिन्दी',
  ho: 'Hiri Motu',
  hr: 'Hrvatski',
  ht: 'Kreyòl ayisyen',
  hu: 'Magyar',
  hy: 'Հայերեն',
  hz: 'Otjiherero',
  ia: 'Interlingua',
  id: 'Bahasa Indonesia',
  ie: 'Interlingue',
  ig: 'Asụsụ Igbo',
  ii: 'Sichuan Yi',
  ik: 'Iñupiaq',
  io: 'Ido',
  is: 'Íslenska',
  it: 'Italiano',
  iu: 'ᐃᓄᒃᑎᑐᑦ',
  ja: '日本語',
  jv: 'Javanese',
  ka: 'ქართული',
  kg: 'Kikongo',
  ki: 'Gĩkũyũ',
  kj: 'Kuanyama',
  kk: 'Қазақ тілі',
  kl: 'Kalaallisut',
  km: 'Khmer',
  kn: 'Kannada',
  ko: 'Korean',
  kr: 'Kanuri',
  ks: 'कश्मीरी ; كشميري',
  ku: 'Kurdî ; كوردی',
  kv: 'коми кыв',
  kw: 'Kernewek',
  ky: 'Кыргыз тили',
  la: 'Latina',
  lb: 'Lëtzebuergesch',
  lg: 'Luganda',
  li: 'Limburgs',
  ln: 'Lingála',
  lo: 'ພາສາລາວ',
  lt: 'Lietuvių kalba',
  lu: 'Tshiluba',
  lv: 'Latviešu valoda',
  mg: 'Fiteny malagasy',
  mh: 'Kajin M̧ajeļ',
  mi: 'Te reo Māori',
  mk: 'македонски јазик',
  ml: 'മലയാളം',
  mn: 'Монгол хэл',
  mr: 'मराठी',
  ms: 'Bahasa Melayu',
  mt: 'Malti',
  my: 'Burmese',
  na: 'Dorerin Naoero',
  nb: 'Norsk bokmål',
  nd: 'isiNdebele',
  ne: 'नेपाली',
  ng: 'Owambo',
  nl: 'Nederlands',
  nn: 'Norsk nynorsk',
  no: 'Norsk',
  nr: 'isiNdebele',
  nv: 'Diné bizaad',
  ny: 'ChiCheŵa',
  oc: 'Occitan',
  oj: 'ᐊᓂᔑᓈᐯᒧᐎᓐ',
  om: 'Afaan Oromoo',
  or: 'ଓଡ଼ିଆ',
  os: 'ирон æвзаг',
  pa: 'ਪੰਜਾਬੀ ; پنجابی',
  pi: 'पाऴि',
  pl: 'Polski',
  ps: 'پښتو',
  pt: 'Português',
  qu: 'Runa Simi',
  rm: 'Rumantsch',
  rn: 'Ikirundi',
  ro: 'Română',
  ru: 'Русский',
  rw: 'Ikinyarwanda',
  sa: 'संस्कृतम्',
  sc: 'Sardu',
  sd: 'सिन्धी ; سنڌي',
  se: 'Davvisámegiella',
  sg: 'Yângâ tî sängö',
  si: 'සිංහල',
  sk: 'Slovenčina',
  sl: 'Slovenščina',
  sm: "Gagana fa'a Samoa",
  sn: 'ChiShona',
  so: 'Soomaaliga',
  sq: 'Shqip',
  sr: 'Српски',
  ss: 'SiSwati',
  st: 'Sesotho',
  su: 'Basa Sunda',
  sv: 'Svenska',
  sw: 'Kiswahili',
  ta: 'தமிழ்',
  te: 'Telugu',
  tg: 'Тоҷикӣ',
  th: 'ไทย',
  ti: 'ትግርኛ',
  tk: 'Türkmen',
  tl: 'Wikang Tagalog',
  tn: 'Setswana',
  to: 'Faka Tonga',
  tr: 'Türkçe',
  ts: 'Xitsonga',
  tt: 'татарча ; tatarça',
  tw: 'Twi',
  ty: 'Reo Tahiti',
  ug: 'ئۇيغۇرچە ; Uyghurche',
  uk: 'Українська',
  ur: 'اردو',
  uz: 'Uzbek',
  ve: 'Tshivenḓa',
  vi: 'Tiếng Việt',
  vo: 'Volapük',
  wa: 'Walon',
  wo: 'Wolof',
  xh: 'isiXhosa',
  yi: 'ייִדיש',
  yo: 'Yorùbá',
  za: 'Zhuang',
  zh: '中文',
  zu: 'isiZulu',
}
